module.exports = __webpack_public_path__ + "static/img/logo12.a851ddb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/logo12.png
// module id = hNa2
// module chunks = 1